import { Divider, Form, Input } from "antd";
import "../styles.css";
import TextArea from "antd/es/input/TextArea";
import "../../../../components/modals/invitations/styles.css";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

const CohortCardEdit = ({ cohort, form }) => {
  const { t } = useTranslation();

  useEffect(() => {
    form.setFieldsValue({
      value: cohort?.value || "",
      description: cohort?.description || "",
    });
  }, [cohort, form]);

  return (
    <div
      className="categories-modal"
      style={{ position: "relative", bottom: 16 }}
    >
      <Divider />
      <Form form={form}>
        <Form.Item key={"value"}>
          <div className="invite-user__field">
            <p className="invite-user__field__name">{t("cohort.modal.name")}</p>
            <Form.Item name={"value"} noStyle>
              <Input
                data-testid="cohort-name"
                placeholder={t("administration.cohort.name_placeholder")}
                variant="borderless"
                className="categories-drawer__body__title"
                maxLength={256}
              />
            </Form.Item>
          </div>
        </Form.Item>

        <Form.Item key={"description"}>
          <div className="invite-user__field">
            <p className="invite-user__field__name">
              {t("cohort.modal.description")}
            </p>
            <Form.Item name={"description"} noStyle>
              <TextArea
                placeholder={t("administration.cohort.description_placeholder")}
                variant="borderless"
                className="categories-drawer__body__description"
                maxLength={1000}
              />
            </Form.Item>
          </div>
        </Form.Item>
      </Form>
      <Divider style={{ margin: 0 }} />
    </div>
  );
};

export default CohortCardEdit;
